module.exports = __webpack_public_path__ + "static/media/pcb.34590594.jpeg";